package com.xtream.data_kmp.db.repo

import com.xtream.data_kmp.AppConfig
import com.xtream.data_kmp.WatchedVodStreams
import com.xtream.data_kmp.db.AppRoomDB


class WatchedVodRepository (
    val db: AppRoomDB,
){
    fun getWatchedStreamFlow( streamId:Int?)=db.watchedVodDao().getSingleFlow(streamId)
    suspend fun getWatchedStream( streamId:Int?)=db.watchedVodDao().getSingle(streamId)
     suspend fun insert(  watchedVodStreams: WatchedVodStreams){
        db.watchedVodDao().insert(watchedVodStreams)
        db.watchedVodDao().deleteByOffset(AppConfig.WATCHED_LIST_LIMIT,-1)
    }
    suspend fun deleteById(id:Int?){
        db.watchedVodDao().deleteById(id)
    }


    suspend fun deleteAll() = db.watchedVodDao().delete()
}